export default __webpack_public_path__ + "static/media/orientation_core.45c6b752.pdf";